import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';
import { Injectable } from '@angular/core';

/**
 * Shows only liters in order creation unit of admixtures
 */
@Injectable()
export class EnableUnitsInAdmixturesFeature implements IFlagFeature {
    name = Features.ENABLE_MULTIPLE_UNITS_IN_ADMIXTURES;

    public isEnabled(container: IToggleContainer): boolean {
        return container[this.name].isEnabled();
    }
}
